import { bankGatewayLabel } from "@/services/payment/bankGateway";
import { Actor, AppointmentStatus, MerchantAppointmentQueueDto } from "@/models/club";
import { Card, Group, Indicator, Text } from "@mantine/core";

type Props = {
    appointment: MerchantAppointmentQueueDto;
}

function AppointmentInfo({ appointment }: Props) {
    return (
        <>
        {appointment && (appointment.actor === Actor.Value10 || appointment.paymentInfo) && <Group justify="space-between"><Text size="sm" c="dimmed">درگاه پرداخت</Text><Text size="sm">{bankGatewayLabel(appointment.bankGateway)}</Text></Group>}
        {appointment?.actor === Actor.Value10 ? (
            <Group justify="space-between">
                <Text>
                    پرداخت آنلاین
                </Text>
            </Group>
        ) : appointment?.actor === Actor.Value20 ? (
            appointment?.status === AppointmentStatus.Value0 ? (
                <Card withBorder>
                    <Group justify="space-between">
                        <Group>
                            <Indicator inline processing color="orange" size={10} />
                            <Text size="xs" pr="5"> مبلغ بیعانه پرداخت نشده است   </Text>
                        </Group>
                    </Group>
                </Card>
            ) : appointment?.status === AppointmentStatus.Value1 && appointment?.paymentInfo !== null ? <Card withBorder>
                <Group justify="space-between">
                    <Group>
                        <Indicator inline processing color="green" size={10} />
                        <Text size="xs" pr="5"> مبلغ بیعانه پرداخت شده است   </Text>
                    </Group>
                </Group>
            </Card> : <></>
        ) : <></>}
        </>
    )
}

export default AppointmentInfo